import { MUSICOS } from "../data/content";
import { useTheme } from "../hooks/useTheme";

const MusicoCard = ({ musico, index, isDark }) => {
    const frontImg = isDark ? musico.instrument_img_night : musico.instrument_img_day;

    return (
        <div
            className="group relative h-[460px] w-full overflow-hidden rounded-2xl bg-card"
            data-testid={`musico-card-${index}`}
        >
            <img
                src={frontImg}
                alt={musico.role}
                className="absolute inset-0 h-full w-full object-cover object-top transition duration-700 group-hover:scale-105"
                loading="lazy"
            />
            {/* elegant gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/40 to-transparent" />
            <div className="absolute inset-0 ring-1 ring-inset ring-gold/20 rounded-2xl" />

            {/* bottom content */}
            <div className="relative z-10 flex h-full flex-col justify-end p-8">
                <div className="flex items-center gap-3">
                    <span className="text-[10px] font-bold uppercase tracking-[0.3em] text-gold">
                        {String(index + 1).padStart(2, "0")}
                    </span>
                    <span className="h-px flex-1 bg-gold/40" />
                </div>
                <h3 className="mt-3 font-display text-4xl leading-none text-white">
                    {musico.role}
                </h3>
                <div className="mt-4 h-px w-12 bg-gold" />
            </div>
        </div>
    );
};

export const Musicos = () => {
    const { theme } = useTheme();
    const isDark = theme === "dark";
    return (
        <section
            id="musicos"
            data-testid="musicos-section"
            className="relative overflow-hidden bg-[hsl(var(--secondary))] py-24 md:py-32"
        >
            <div className="pointer-events-none absolute inset-x-0 top-0 h-px gold-line" />

            <div className="mx-auto max-w-7xl px-6 md:px-10">
                <div className="mx-auto max-w-2xl text-center">
                    <div className="mb-6 inline-flex items-center gap-3">
                        <span className="h-px w-12 bg-gold" />
                        <span className="text-xs font-semibold uppercase tracking-[0.35em] text-gold">
                            Nuestros Músicos
                        </span>
                        <span className="h-px w-12 bg-gold" />
                    </div>
                    <h2 className="font-display text-4xl leading-tight text-foreground sm:text-5xl md:text-6xl">
                        El corazón del
                        <span className="text-gold"> Mariachi.</span>
                    </h2>
                    <p className="mt-5 text-muted-foreground md:text-lg">
                        Seis artistas, seis historias detrás de cada instrumento.
                        <span className="mt-2 block text-[11px] uppercase tracking-[0.3em] text-gold">
                            Tip · cambia entre modo diurno y nocturno para ver el otro uniforme
                        </span>
                    </p>
                </div>

                <div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
                    {MUSICOS.map((m, i) => (
                        <MusicoCard key={m.name} musico={m} index={i} isDark={isDark} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Musicos;
